export default {
    delete_message_after_send: '发送后直接删除消息',
    delete_message_after_send_tip: '聊天记录将被一并删除，建议用于新客户推广。',
    buttonNoSend: '重要通知：WhatsApp按钮功能终止',
    buttonSend: '重要通知：WhatsApp按钮功能恢复',
    period_t: '。',
    semicolon_t: '；',
    colon_t: '：',
    help_center_t: '帮助中心',
    how_to_t: '使用教程',
    leave_a_t: '求五星好评',
    support_t: '在线客服',
    more_free_t: '更多工具（免费）',
    share_t: '分享',
    send_messages_t: '发送消息',
    whatsapp_numbers_t: 'WhatsApp 号码',
    million_leads_t: '百万免费线索！',
    country_code_t: '国家区号+手机号（号码间用逗号分隔），例如：+8613135587131，+8619197646821',
    message_text_t: '消息内容',
    select_template_t: '选择消息模版',
    save_as_t: '另存为模版',
    help_there_t:
        '您好，我想给您推荐一个WhatsApp批量消息发送工具。\n' +
        '1.如果您感兴趣，请回复“是”，我将向您展示更多细节。\n' +
        '2.如果打扰到您，请回复“否”，我将不再给您发送任何消息。\n',
    sending_settings_t: '发送设置',
    messages_will_t: '消息将按照您设定的时间间隔，依次发送。',
    sending_interval_t: '发送时间间隔',
    seconds_t: '秒',
    send_t: '发送',
    sending_t: '发送中......',
    send_messages_pro_t: '发送消息·升级版',
    whatsapp_numbers_excel_t: 'Excel批量发送',
    download_excel_template_t: '下载模版',
    fill_it_t: '按规则填写',
    upload_excel_t: '上传Excel',
    how_to_use_t: '使用教程',
    excel_template_t: '下载模版',
    upload_excel_btn_t: '上传Excel',
    send_to_t: '群成员消息群发',
    send_to_label: 'Label成员消息群发',
    no_data_t: '无数据',
    select_joined_send_t: '选择您已加入的群组',
    select_joined_send_label: '选择您已创建的标签',
    apologize_for_t: '消息退订',
    add_timestamp_t: '添加发送时刻',
    if_it_t: '如果打扰到您，请回复“否”，我将不再给您发送任何消息。',
    send_attachments_t: '添加附件',
    button_attachments_t: '按钮消息',
    button_text_t: '文本',
    button_link_t: '链接',
    button_call_t: '电话',
    button_text_tip: '使用|分隔（最多3个）。',
    button_link_tip: '将URL放在括号中（最多1个）。',
    button_call_tip: '将电话放在括号中（最多1个）',
    Example: '实例',
    image_t: '图片',
    video_t: '视频',
    document_t: '文件',
    contact_t: '名片',
    use_placeholder_t: '上传Excel并使用占位符',
    personalized_t: '个性化：',
    how_to_use_personalized_t: '如何编辑个性化消息',
    group_tools_t: '群工具',
    export_group_t: '导出群成员',
    select_joined_export_t: '请选择您已加入的群组',
    exclude_group_t: '排除群管理员',
    download_excel_t: '导出群成员',
    send_wow_t: '向 WhatsApp 群组发送消息：',
    this_feature_t: '这个功能可以帮你找到更多相关的群组',
    under_development_text_t: '正在开发中，请参阅',
    under_development_link_t: '教程',
    if_you_text_t: '如果你有任何问题，请',
    if_you_link_t: '联系我们',
    statistics_t: '数据看板',
    more_tools_t: '更多工具',
    current_sending_t: '当前发送进度',
    please_do_t: '请不要离开，下一条信息即将发出',
    every_t: '每80条信息分为一组，每组时间间隔3-5分钟。',
    send_results_t: '发送结果',
    too_many_t: '聊天太多难以应付？我们帮您高效管理。',
    total_t: '合计',
    deduplicated_t: '去重后',
    sent_successfully_t: '发送成功',
    failed_to_t: '发送失败',
    troubleshooting_t: '问题定位',
    no_network_t: '无网络',
    please_click_first_t: '请点击',
    please_click_second_t: '“失败重试”',
    wrong_number_t: '号码错误',
    check_the_first_t: '检查号码',
    check_the_second_t: '格式',
    check_if_first_t: '检查号码是否',
    check_if_second_t: '存在并活跃',
    pause_t: '暂停',
    continue_t: '继续',
    export_results_t: '导出结果',
    retry_failed_t: '失败重试',
    when_the_t: '当信息发送失败时，请点击“失败重试”按钮。',
    rate_for_t: '如果Bulk Sender对您有帮助，求五星好评～',
    please_check_t: '请检查已上传的Excel，确保第一列已填入正确的whatsapp号码。',
    check_the_entered_t: '请检查您输入的号码格式。',
    please_enter_please_t: '请输入至少',
    please_enter_one_t: '一个',
    please_enter_number_t: ' 号码。',
    the_template_t: '该模板已保存。',
    please_enter_a_t: '请至少输入一条消息。',
    please_enter_at_t: '请输入至少一个号码。',
    safety_1_t: '安全提示',
    safety_2_t: '为避免您的帐户被禁止，我们建议：',
    safety_3_1_t: '账户已注册',
    safety_3_2_t: '天',
    safety_4_1_t: '手机和网站的',
    safety_4_2_t: 'IP在同一个地区',
    safety_5_1_t: '不要',
    safety_5_2_t: '频繁切换IP',
    safety_6_t: '您可以发送的消息数量：',
    safety_7_t: '最高50条 - 第一天 ',
    safety_8_t: '最高300条 - 第二天及以后 ',
    agree_t: '同意并继续',
    donot_t: '不再显示',
    suggest_1_t: '为避免发送失败，我们建议：',
    suggest_2_t: '不要切换聊天窗口。',
    suggest_3_t: '在自动发送消息时不要关闭页面。',
    suggest_4_t: '仅开启 Bulk Sender。',
    suggest_5_t: '同类型扩展会导致发送故障，请关闭其他扩展，只打开Sender。',
    about_t: '关于 WhatsApp 已连接的设备',
    uploading_t: '正在上传附件，请稍候。',
    image_limit_t: '每次发送的图像/视频的上限为 30 个。',
    size_limit_t: '您发送的每个图像/视频的大小限制为 16 MB。',
    choose_t: '导出前请选择一个组。',
    you_were_t: '您已从群聊中删除。',
    failed_connect_1_t: '连接WhatsApp失败，请刷新页面重试。',
    failed_connect_2_1_t: '否则，',
    failed_connect_2_2_t: '无法正常运行。',
    sent_at_t: '\n发送时刻: {{time stamp}}',
    first_time_1_t: '已达首日发送上限（50条），为了您的账号安全，请于',
    first_time_2_t: '后继续使用。\n\n从下一天起，发送额度将提升至300条/日。',
    second_time_1_t: '为了您的账号安全，请于',
    second_time_2_t: '后继续使用。\n\n从下一天起，发送额度将提升至300条/日。',
    send_Group_message_wow: '给群组发送消息?',
    wow_link_t: 'WA Group Sender',
    wow_link_help: '🚀 🚀 可以帮助您向<b>群组、社区</b>和<b>广播发送消息。 </b>',
    tool_choose_file: '选择文件格式：', //谷歌翻译
    tool_export_info: '从群组导出信息', //谷歌翻译
    tool_export_now: '立即导出', //谷歌翻译
    tool_export_chat: '从聊天列表导出信息：', //谷歌翻译
    tool_export_all: '从聊天列表导出所有联系人信息', //谷歌翻译
    tool_export_no_all: '从聊天列表导出未保存的联系人信息', //谷歌翻译
    tool_export_labels: '从Label导出信息',
    btn_msg_remind_title: '我们很高兴向您宣布[Bulk Sender]的全新功能更新！！！',
    btn_msg_remind_1: '🚀 **新功能: [',
    btn_msg_remind_2: '发送Button按钮消息',
    btn_msg_remind_3: ']**',
    btn_msg_remind_4: '点击下方按钮，我们将',
    btn_msg_remind_5: '📱 **立即体验:**',
    btn_msg_remind_6: '免费',
    btn_msg_remind_7: '为您发送一次按钮消息，让您更加直观的进行体验',
    but_msg_remind_button: '立即体验',
    notWork1: '无法连接到您的 WhatsApp，请刷新页面重新连接。',
    notWork2: '否则，免费的 WhatsApp 联系人和群号码导出器将无法工作。',
    popup: {
        faq: '常见问题',
        excludeAdmin: '排除管理员',
        fileFormat: '选择文件格式:',
        labelGroup: '选择群组导出:',
        labelChatList: '从聊天列表导出信息:',
        button: {
            group: '从群组导出号码',
            contacts: '导出联系人',
        },
    },
    review1: {
        title: '免费使用！',
        desc: '留下评论以解锁无限验证访问！',
        tip: '目前支持导出最多10次。',
        button: {
            cancel: '不，现在发送！',
            contacts: '留下评论'
        }
    },
    review2: {
        groupTitle: '方法1：加入群组',
        title: '方法1：留下评论',
        desc: '评价我们并留下评论以解锁无限访问！👋',
        step: {
            here: '点击这里',
            1: ' 前往扩展商店。',
            2: ' 评价我们 ⭐️⭐️⭐️⭐️⭐️ 并留下评论。',
            3: ' 截图、保存并上传图片。'
        },
        button: {
            submit: '提交',
            groupJoin: '点击并加入群组以解锁'
        }
    },
    review3: {
        tip1: '感谢您的参与！',
        tip2: '我们将在1~5分钟内审核并授予您无限制的访问权限。'
    },
    MultiAccountLimit: {
        title: "还有更多账号要导出联系人？",
        content1: `谷歌插件内最多支持被用于3个WhatsApp账号。 <br>
        如需使用更多WhatsApp账号和更多设备，推荐尝试 WADesk - 专注 WhatsApp 多账号私域营销和协同管理的客户端工具。<br>
        咨询客服获得免费试用👉 `,
        contactUsLink: 'https://wadesk.io/',
        contactUs: '咨询客服，获得免费试用'
    },
    MultiDeviceLimit: {
        title: "需要在更多设备上使用？",
        content1: `谷歌插件内，每个WhatsApp最多支持在3个设备登录。 <br>
        如需使用更多WhatsApp账号和更多设备，推荐尝试 WADesk - 专注 WhatsApp 多账号私域营销和协同管理的客户端工具。<br>
        咨询客服获得免费试用👉 `,
        contactUsLink: 'https://wadesk.io/',
        contactUs: '咨询客服，获得免费试用'
    },
    Permission: {
        reachCountLimit: "已达到导出次数的最大限制。"
    },
    Safety: {
        Suggestions: "安全建议",
        tip1: "为了避免您的账户被封禁，我们建议：",
        tip2: `账户注册时间 <i class="boldFont">≥ 15</i> 天`,
        tip3: `手机和网站的 <i class="boldFont">IP地址在同一地区</i>`,
        tip4: `<i class="boldFont">不要</i> 频繁切换IP地址`,
        CouldSend: `您可以发送的信息数量：`,
        maxFirstDay: `第一天最多50条`,
        maxSecondDay: `第二天起最多300条`,
        AgreeAndContinue: ` 同意并继续 `,
        NotShowAgain: ` 不再显示`,
    },
    Safety2: {
        Suggestions: "为了避免发送失败，我们建议：",
        tip1: "不要切换聊天窗口。",
        tip2: `在消息自动发送时请保持在此页面。`,
        AgreeAndContinue: ` 同意并继续 `,
        NotShowAgain: ` 不再显示`,
    }
}
